export const notificationsFr = {
  title: "Notifications",
  open: "Notifications (%{smart_count} non lue) |||| Notifications (%{smart_count} non lues)",
  empty: "Aucune notification",
  mark_all: "Tout marquer comme lu",
  // GAVION X4: daily digest opt-out (Profil)
  digest: {
    title: "Résumé quotidien",
    description:
      "Chaque matin de jour ouvrable à 7 h 30 : vos rappels et démos du jour, vos prospects chauds, les demandes d'arrêt à traiter et vos résultats de la veille. Vous le recevez dans le CRM et, si votre boîte Outlook est connectée, par courriel.",
    toggle: "Recevoir le résumé quotidien",
    on: "Résumé quotidien activé",
    off: "Résumé quotidien désactivé",
    error: "Impossible d'enregistrer votre choix. Réessayez.",
  },
  // GAVION rep-missed-call: the rep's own « Appel manqué » email switch (Profil)
  missed_call: {
    title: "Courriel « Appel manqué »",
    toggle: "Courriel automatique après un appel sans réponse",
    help: "Désactivé par défaut. Une fois activé, après « Pas de réponse » ou « Message laissé », la compagnie reçoit le courriel « Appel manqué — Gala » depuis votre Outlook (une seule fois par compagnie).",
    edit: "Modifier le courriel",
    edit_en: "Version anglaise",
    on: "Courriel « Appel manqué » activé : il partira après vos appels sans réponse",
    off: "Courriel « Appel manqué » désactivé",
    error: "Impossible d'enregistrer votre choix. Réessayez.",
  },
};
